import { IEvent, IHost } from "@Interfaces";
import { ADDRESS_TYPE, EVENT_ENUM, EVENT_TYPE, MEDIA, isEmpty } from "@Utils";
import { IAddressInfo } from "./IAddressInfo";

export const getAddressInfoProps = ({
    eventData,
    hostData,
}: {
    eventData: IEvent.IEventData;
    hostData?: IHost.IHostData;
}): IAddressInfo.IProps => {
    const platform = eventData?.video_platform;
    let icon: string;
    let title: string;
    let description: string;
    const { show_creator_personal_address, venue_details } = eventData;
    const personalAddressTitle = hostData?.personal_address_title;

    switch (eventData?.address_type) {
        case ADDRESS_TYPE.MEET_AUTO_GENERATE:
            icon = MEDIA.ICONS.CALL_PLATFORMS.google_meet;
            title = "Video call on Google meet";
            description = "Link will be generated post booking";
            break;
        case ADDRESS_TYPE.PERSONAL_ADDRESS:
            icon = MEDIA.ICONS.LOCATION;
            title =
                personalAddressTitle && !isEmpty(personalAddressTitle)
                    ? personalAddressTitle
                    : `At ${hostData?.name || "creator"}’s address`;
            description = show_creator_personal_address
                ? venue_details?.address || ""
                : "Complete address and other details will be provided post payment";
            break;
        case ADDRESS_TYPE.CUSTOMER_ADDRESS:
            icon = MEDIA.ICONS.LOCATION;
            title = "At your personal address";
            description =
                "We will ask for your address and share further details post payment";
            break;
        case ADDRESS_TYPE.WHATSAPP:
            icon = MEDIA.ICONS.CALL_PLATFORMS.whatsapp;
            title =
                eventData?.metadata?.call_section_title || "Call on WhatsApp";
            description = eventData?.metadata?.call_section_description || "";
            break;
        case ADDRESS_TYPE.PHONE_NUMBER:
            icon = MEDIA.ICONS.CALL_PLATFORMS.phone_call;
            title = eventData?.metadata?.call_section_title || "Call on Phone";
            description = eventData?.metadata?.call_section_description || "";
            break;
        case ADDRESS_TYPE.EXISTING_LINK:
        case ADDRESS_TYPE.ZOOM_AUTO_GENERATE:
        default:
            icon = MEDIA.ICONS.CALL_PLATFORMS.zoom;
            title =
                eventData?.metadata?.call_section_title ||
                `Video call${platform ? ` on ${platform?.title}` : ""}`;
            description =
                eventData?.metadata?.call_section_description ||
                "Joining link and password will be relayed to you post booking";
            break;
    }
    if (eventData.type === EVENT_TYPE.TELEGRAM) {
        icon = MEDIA.ICONS.CALL_PLATFORMS.telegram;
        title =
            eventData?.metadata?.call_section_title ||
            "Paid Telegram Community";
        description = eventData?.metadata?.call_section_description || "";
    }

    if (eventData.type === EVENT_TYPE.WHATSAPP) {
        icon = MEDIA.ICONS.CALL_PLATFORMS.whatsapp;
        title =
            eventData?.metadata?.call_section_title || "Join WhatsApp Group";
        description = eventData?.metadata?.call_section_description || "";
    }

    return {
        hideComponent:
            !EVENT_ENUM[eventData?.type]?.SHOW_ADDRESS ||
            eventData?.metadata?.hide_creator_detail ||
            eventData.type === EVENT_TYPE.BRANDED_COMMUNITY,

        // TODO: Delete the following comment, if it remains unsed till March 3, 2023
        /*
        // If there is a event type title set by the admin panel show that
        displayType: eventData?.type_display,
        */
        icon,
        title,
        description,
    };
};
